export default {
	user: 'Benutzer',
	admin: 'Administrator',
	manager: 'Manager',
	super: 'Super-Admin',
	addRole: 'die Rolle hinzufügen',
	name: 'Name',
	alias: 'Username',
	description: 'Beschreibung',
	permissions: 'Möglichkeiten/Erlaubnisse',
	roleEdit: 'Rolle bearbeiten',
	areYouSureYouWantToDeleteRole: 'Wollen Sie wirklich die Rolle entfernen?'
};
